/**
 * 配備後の古い画面を見つけて、読み込み直すための仕組み。
 *
 * サーバはすべての /api 応答に「いま配っている画面の版」（入口JSのパス）を付ける。
 * 画面は自分が動かしている入口JSのパスと比べ、違っていれば古い画面と判断する。
 * 開発サーバ（Vite）では版を付けないので何もしない。
 */

let outdated = false;
const listeners = new Set<() => void>();

/** いま動いている画面の入口JSのパス（例 /assets/index-XXXX.js）。見つからなければ null。 */
export function runningVersion(): string | null {
  const script = document.querySelector<HTMLScriptElement>(
    'script[type="module"][src*="/assets/index-"]',
  );
  return script ? new URL(script.src, window.location.href).pathname : null;
}

/** API応答に付いていた版を受け取る。自分と違えば「古い」と記録して知らせる（1回だけ）。 */
export function noteServerVersion(serverVersion: string | null): void {
  if (outdated || !serverVersion) return;
  const mine = runningVersion();
  if (!mine || mine === serverVersion) return;
  outdated = true;
  for (const l of listeners) l();
}

export const isOutdated = (): boolean => outdated;

export function subscribeOutdated(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** テスト用。 */
export function resetOutdatedForTest(): void {
  outdated = false;
}

const TEXT_ENTRY = new Set(['text', 'search', 'tel', 'number', 'email', 'url', 'password', '']);

/**
 * いま読み込み直しても作業を失わないか。
 * ・送信中の操作がない
 * ・確認シート・ダイアログが開いていない、理由の入力欄が開いていない
 * ・文字を打っている途中ではない（入力欄にフォーカスがあり、中身がある）
 */
export function isSafeToReload(pendingMutations: number): boolean {
  if (pendingMutations > 0) return false;
  if (document.querySelector('.scrim, .sheet, .dialog, .card.is-editing')) return false;
  const active = document.activeElement;
  if (active instanceof HTMLTextAreaElement && active.value) return false;
  if (active instanceof HTMLInputElement && TEXT_ENTRY.has(active.type) && active.value)
    return false;
  return true;
}
